import React, { useContext } from 'react';
import { Context } from 'components/Store';
import { FormikInput } from 'components/UiKit/FormikFields';

const InsuranceId = () => {
  const [{ isEnableInfoTabEdit }] = useContext(Context);
  return (
    <FormikInput
      name="insuranceId"
      placeholder="Enter insurance ID"
      label="Insurance ID"
      disabled={!isEnableInfoTabEdit}
    />
  );
};

export default InsuranceId;
